import React from "react";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import FAQElement from "components/FAQ";

const FAQs = () => {
  const FAQdata = [
    {
      q: "What is RAted Fans?",
      a: "Rated Fans helps artists create customizable Smart URLs and Presave links for music, videos, and social media. These all-in-one links make sharing content easy, boosting engagement and maximizing reach across platforms"
    },
    {
      q: "How do Smart URLs work?",
      a: "Smart URLs are customizable links that direct fans to your music and videos across streaming platforms like Spotify, Apple Music, and Tidal. They also include your social media profiles, providing a single destination for all your content."
    },
    {
      q: "What are Pre-save links and how do they help?",
      a: "Pre-save links let fans save your upcoming releases on their favorite platforms before the official release. This builds excitement and ensures early plays and views as soon as your content goes live, with notifications sent to fans."
    },
    {
      q: "Can I customize my Smart URLs and Presave links?",
      a: "Yes, Rated Fans lets you fully customize your Smart URLs and Presave links. Personalize them to match your brand, choose platforms to feature, and add social media links to boost fan engagement."
    },
    {
      q: "Can I use Rated Fans for music videos as well?",
      a: "Yes, Rated Fans supports both music tracks and music videos. Create Smart URLs and Presave links for your videos and distribute them to platforms like Apple Music, Vevo, and Tidal for easy fan access."
    }
  ];
  return (
    <Container>
      <Typography
        color={Colors.white300}
        size="3.6rem"
        weight="semibold"
        align="center"
        m_size="4xl"
      >
        Frequently asked questions
      </Typography>
      <Typography
        color={Colors.grey600}
        size="2xl"
        m_size="lg"
        mt="2"
        align="center"
      >
        Everything you need to know about the product and billing.
      </Typography>
      <Items>
        {FAQdata.map(({ q, a }, i) => {
          return (
            <Item key={i}>
              <FAQElement q={q} a={a} />
            </Item>
          );
        })}
      </Items>
    </Container>
  );
};

export default FAQs;

const Container = styled.div`
  margin-top: 8rem;
  padding-bottom: 20rem;
`;

const Items = styled.div`
  margin-top: 6.8rem;
  width: 65%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-top: 3.2rem;
  }
`;
const Item = styled.div`
  margin-bottom: 3.2rem;
  width: 100%;
`;
